import axios from 'axios';

export default (headers = { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' }, url = new URL(window.location)) => axios.create({
  baseURL: '/api/v2/tmaps',
  timeout: 30000,
  headers,
  withCredentials: true,
  responseType: 'json',
  cache: false,
});
